import React, {PropTypes} from 'react';

const InputHidden = ({input}) => <input {...input} type="hidden" />;

InputHidden.propTypes = {
  input: PropTypes.object.isRequired,
};

export default InputHidden;
